export const HEADER_NAV_LINKS = [
    {
        label: "Главная",
        to: "/",
    },
    {
        label: "Возможности",
        to: "/possibilities",
    },
    {
        label: "Тарифы",
        to: "/tariffs",
    },
    {
        label: "Для УК",
        to: "/management",
    },
    {
        label: "Для жителей",
        to: "/residents",
    },
    {
        label: "Блог",
        to: "/blog",
    }
];